import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@app/services/modal.service';

@Component({
  selector: 'app-modal-payment-claims',
  templateUrl: './modal-payment-claims.component.html',
  styleUrls: ['./modal-payment-claims.component.scss']
})
export class ModalPaymentClaimsComponent implements OnInit {

  @Input() message: typeMessage;
  @Input() messageText: string;
  @Output() closeEvent:EventEmitter<boolean> = new EventEmitter();

  constructor(
    public modalService: ModalService,
  ) { }

  ngOnInit() {
  }

  handleCancel(){
    this.closeEvent.emit(false)
    this.modalService.close();
  }
  
  handleSuccess(){
    this.closeEvent.emit(true)
    this.modalService.close();
  }

}

export type typeMessage = 'success'|'error'|'giveUp';
